// Frontend role helpers. Internal role strings are preserved in the DB;
// the UI collapses them to three display roles.
export const ROLE_ADMIN = "Admin";
export const ROLE_SUPERVISOR = "Supervisor";
export const ROLE_USER = "User";
export const ROLE_DEMO = "Demo";

export function isDemo(user) { return !!user && !!user.is_demo; }

export function displayRole(user) {
  if (!user) return "";
  if (user.is_demo) return ROLE_DEMO;
  if (user.display_role) return user.display_role;
  const internal = user.role || "";
  if (internal === "system_owner" || internal === "admin") return ROLE_ADMIN;
  if (internal === "supervisor") return ROLE_SUPERVISOR;
  return ROLE_USER;
}
export function isAdmin(user) { return !isDemo(user) && displayRole(user) === ROLE_ADMIN; }
export function isSupervisor(user) { return !isDemo(user) && displayRole(user) === ROLE_SUPERVISOR; }
export function isUser(user) { return !isDemo(user) && displayRole(user) === ROLE_USER; }
// iter20: Demo is strictly read-only. Every capability check returns false.
export function canEditItems(user) { return !isDemo(user) && (isAdmin(user) || isSupervisor(user)); }
export function canManageUsers(user) { return !isDemo(user) && isAdmin(user); }
export function canReverseTransactions(user) { return !isDemo(user) && isAdmin(user); }
export function canImportMasterFile(user) { return !isDemo(user) && isAdmin(user); }
export function canWriteInventory(user) { return !isDemo(user); }
